import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { FolderType } from '../constants';

export const useLogCompleteRemoveGoods = (folderType: FolderType) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({
      name: 'COMPLETE_REMOVE_GOODS',
      channel: ['amplitude', 'ablylog', 'braze'],
      analytics: { FOLDER_TYPE: folderType },
    });
  }, [logAnalyticsEvent, folderType]);
};
